var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ib-button-generating d-flex justify-content-center align-items-center disabled",class:_vm.classes,style:({ height: _vm.height }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[(_vm.loading)?[_c('ib-spinner',{attrs:{"color":_vm.color}})]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }